export default __webpack_public_path__ + "static/media/medicenter_logo.90d97e9e.png";